<template>
    <v-card class="card pa-2 mb-5">
        <v-card-text class="pa-2">
            <h1 class="titulo">Filtros:</h1>
            <v-form ref="form">
                <v-row>
                    <v-col v-if="!isDraft" cols="12" sm="6" md="3">
                        <v-text-field label="Nº da proposta: "
                                      id="FieldProposta"
                                      v-model="id_documento"
                                      v-mask="'###########'"
                                      outlined />
                    </v-col>
                    <v-col v-if="!isDraft" cols="12" sm="6" md="3">
                        <v-select id="FieldStatusContrato"
                                  label="Status do contrato: "
                                  outlined
                                  menu-props="offsetY"
                                  :items="statusContrato"
                                  hide-details
                                  clearable
                                  :disabled="id_documento !== ''"
                                  v-model="custom_filter.status"
                                  placeholder="Selecione o status do contrato"
                                  item-text="name"
                                  item-value="value" />
                    </v-col>
                    <v-col v-if="!isDraft" cols="12" sm="6" md="3">
                        <v-select id="FieldStatusVenda"
                                  label="Status da venda: "
                                  menu-props="offsetY"
                                  :items="getStatusPedidosFormatados(filterData.status_vendas)"
                                  :disabled="id_documento !== ''"
                                  hide-details
                                  clearable
                                  outlined
                                  v-model="custom_filter.status_pedido"
                                  placeholder="Selecione o status da venda"
                                  item-text="name"
                                  item-value="value" />
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <m-text-field v-mask="['###.###.###-##','##.###.###/####-##']"
                                      label="CPF/CNPJ do cliente: "
                                      outlined
                                      :rules="[$rules.cpf_cnpj]"
                                      :disabled="id_documento !== ''"
                                      v-model="custom_filter.cpf_cnpj" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <date-time-range v-model="data_hora_range" :hide-time="true" :rules="[$rules.required]" :shortcut="true" label="Data/Hora" />
                    </v-col>
                    <v-col cols="12" md="3">
                        <m-text-field
                                label="ID Carrinho: "
                                outlined
                                :disabled="id_documento !== ''"
                                v-model.number="custom_filter.id_carrinho"
                                v-input-filter="[$filters.numeric]"
                        />
                    </v-col>
                    <v-col cols="12" md="3">
                        <m-text-field
                                outlined
                                label="Quantidade de Cotas: "
                                :disabled="id_documento !== ''"
                                v-input-filter="[$filters.numeric]"
                                class="required"
                                v-model="custom_filter.qtd_cotas_carrinho" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="mt-md-7">
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-btn color="primary" @click="abrirFiltro" block :disabled="id_documento !== ''">
                                    <v-icon small class="mr-1">rod-filter</v-icon>
                                    Mais filtros
                                    <v-icon>chevron_right</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col cols="12" sm="3" class="mt-3 mt-sm-0">
                                <v-btn color="primary" @click="filtrar" block>
                                    Filtrar
                                </v-btn>
                            </v-col>
                            <v-col cols="12" sm="3" class="mt-3 mt-sm-0">
                                <v-btn color="secondary" block @click="limparFiltroDetalhado">
                                    Limpar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-form>
            <TabDialog ref="TabDialog" title="MAIS FILTROS" v-model="aba_filtro_visivel">
                <v-row class="align-center">
                    <v-col cols="6">
                        <Autocomplete label="Descrição do bem: "
                                      id="FieldDescricaoBem"
                                      :disabled="id_documento !== ''"
                                      :items="bens"
                                      attach
                                      v-model="custom_filter.nome_bem"
                                      item-text="nome_bem"
                                      item-value="nome_bem"
                                      outlined />
                    </v-col>
                    <v-col cols="6" class="d-flex d-inline-flex align-center">
                        <MoneyTextField
                                label="Valor do bem: "
                                placeholder="Valor mínimo"
                                :disabled="id_documento !== ''"
                                v-model="custom_filter.range_valor_bem[0]"
                                maxvalue="999999999999"
                                outlined />
                        <p class="mb-0 ml-2 mr-2">a</p>
                        <MoneyTextField
                                placeholder="Valor máximo: "
                                v-model="custom_filter.range_valor_bem[1]"
                                :disabled="id_documento !== ''"
                                maxvalue="999999999999"
                                outlined />
                    </v-col>
                </v-row>
                <v-row class="align-center">
                    <v-col>
                        <m-text-field label="Nome do cliente: "
                                      id="FieldNomeCliente"
                                      v-input-filter="[$filters.text]"
                                      :disabled="id_documento !== ''"
                                      v-model="custom_filter.nome_cliente"
                                      outlined />
                    </v-col>
                    <v-col>
                        <m-text-field label="E-mail do cliente: "
                                      id="FieldEmailCliente"
                                      :disabled="id_documento !== ''"
                                      v-model="custom_filter.email"
                                      outlined />
                    </v-col>
                </v-row>
                <v-row class="align-center">
                    <v-col>
                        <m-text-field label="Grupo da cota: "
                                      id="FieldGrupoDaCota"
                                      v-model="filter.cd_grupo"
                                      :disabled="id_documento !== ''"
                                      v-input-filter="[$filters.alphanumeric]"
                                      outlined />
                    </v-col>
                    <v-col>
                        <m-text-field label="Nº da cota: "
                                      id="FieldNumeroCota"
                                      v-model="custom_filter.cd_cota"
                                      :disabled="id_documento !== ''"
                                      v-input-filter="[$filters.numeric]"
                                      outlined />
                    </v-col>
                </v-row>
                <v-row class="align-center">
                    <v-col v-if="!isDraft">
                        <Autocomplete label="Status da cota: "
                                      attach
                                      :items="filterData.statusAlocacoes"
                                      v-model="custom_filter.status_alocacao"
                                      item-text="label"
                                      item-value="value"
                                      :disabled="id_documento !== ''"
                                      placeholder="Selecione o status da cota" />
                    </v-col>
                    <v-col cols="6">
                        <m-text-field label="Nome plano de venda: "
                                      id="FieldNomePlanoVenda"
                                      :disabled="id_documento !== ''"
                                      v-input-filter="[$filters.alphanumeric]"
                                      v-model="custom_filter.nome_plano"
                                      outlined />
                    </v-col>
                </v-row>
                <v-row class="align-center">
                    <v-col>
                        <DynamicSelect label="Tipo da Cota:"
                                       id="TipoCotaSelect"
                                       v-model="custom_filter.tipo_cota"
                                       placeholder="Selecione o tipo da cota"
                                       endpoint="/dynamic-selects/tipo_cota/tipo_cota_por_pedido/cd_tipo_cota"
                                       :multiple="false"
                                       item-text="label"
                                       attach
                                       item-value="cd_tipo_cota"
                        />
                    </v-col>
                    <v-col>
                        <Autocomplete label="Unidades de negócio logado: "
                                      :items="unidades"
                                      v-model="custom_filter.nm_unidade_negocio"
                                      item-text="label"
                                      attach
                                      item-value="nome"
                                      :disabled="id_documento !== ''"
                                      placeholder="Selecione a unidade de negócio" />
                    </v-col>
                </v-row>
                <v-row class="align-center">
                    <v-col>
                        <m-text-field label="Código P.V: "
                                      id="FieldPontoVenda"
                                      v-input-filter="[$filters.numeric]"
                                      :disabled="id_documento !== ''"
                                      v-model="custom_filter.cd_ponto_venda"
                                      outlined />
                    </v-col>
                    <v-col>
                        <m-text-field
                                v-mask="['###.###.###-##','##.###.###/####-##']"
                                label="CPF/CNPJ P.V: "
                                :rules="[$rules.cpf_cnpj]"
                                id="FieldCpfCnpjPv"
                                :disabled="id_documento !== ''"
                                v-model="custom_filter.cpf_cnpj_pv"
                                outlined />
                    </v-col>
                </v-row>
                <v-row class="align-center">
                    <v-col>
                        <m-text-field label="Nome do comissionado: "
                                      id="FieldComissionado"
                                      v-input-filter="[$filters.cd_nome]"
                                      :disabled="id_documento !== ''"
                                      v-model="custom_filter.nm_comissionado"
                                      outlined />
                    </v-col>
                    <v-col>
                        <m-text-field label="N° da reserva: "
                                      id="FieldReserva"
                                      v-input-filter="[$filters.numeric]"
                                      :disabled="id_documento !== ''"
                                      v-model="filter.id_reserva"
                                      outlined />
                    </v-col>
                </v-row>
                <v-row class="align-center">
                    <v-col v-if="!isDraft" cols="6">
                        <m-text-field label="Código do pagamento: "
                                      id="FieldCodigoPagamento"
                                      v-input-filter="[$filters.alphanumeric]"
                                      :disabled="id_documento !== ''"
                                      v-model="filter.codigo_pagamento_cliente"
                                      outlined />
                    </v-col>
                    <v-col cols="6">
                        <v-select id="FieldTipoNegociacaoFuro"
                                  label="Negociação de furo: "
                                  outlined
                                  menu-props="offsetY"
                                  :items="tipoNegociacaoFuro"
                                  v-model="filter.opcao_furo"
                                  :disabled="id_documento !== ''"
                                  clearable
                                  attach
                                  item-text="name"
                                  item-value="value" />
                    </v-col>
                </v-row>
                <v-row class="align-center">
                    <v-col>
                        <p class="text--darkgray mt-10">Prazo de comercialização: </p>
                        <v-range-slider
                                v-model="custom_filter.range_prazo_comercializacao"
                                :min="limites_filtro.min_prazos"
                                :max="limites_filtro.max_prazos"
                                :step="1"
                                color="secondary"
                                :disabled="id_documento !== ''"
                                track-color="gray"
                                track-fill-color="secondary">
                            <template v-slot:thumb-label="param">
                                <span>{{ param.value }}</span>
                            </template>
                        </v-range-slider>
                        <div class="d-flex justify-space-between">
                            <p style="width: 30px">{{ limites_filtro.min_prazos }}</p>
                            <p style="width: 30px">{{ limites_filtro.max_prazos }}</p>
                        </div>
                    </v-col>
                    <v-col cols="6">
                        <Autocomplete label="Forma do Pagamento" outlined
                                      id="FieldFormasPagamento"
                                      :items="filterData.formasPagamento"
                                      item-text="name"
                                      attach
                                      class="mb-n3"
                                      item-value="value"
                                      :disabled="id_documento !== ''"
                                      v-model="custom_filter.forma_pagamento"
                                      placeholder="Selecione a Forma do Pagamento" />
                    </v-col>
                </v-row>
                <v-row class="align-center">
                    <v-col v-if="!isDraft" cols="6">
                        <Autocomplete label="Status do Pagamento" outlined
                                      id="FieldStatusPagamento"
                                      :items="filterData.statusPagamento"
                                      item-text="name"
                                      item-value="value"
                                      attach
                                      :disabled="id_documento !== ''"
                                      v-model="custom_filter.status_pagamento"
                                      placeholder="Selecione o Status do Pagamento" />
                    </v-col>
                    <v-col v-if="!isDraft" cols="6">
                        <m-text-field label="Id do contrato: "
                                      id="FieldIdContrato"
                                      :disabled="id_documento !== ''"
                                      v-model="custom_filter.hash_contrato"
                                      outlined />
                    </v-col>
                </v-row>
                <v-row class="align-center">
                    <v-col>
                        <Autocomplete label="Origem da Venda: " outlined
                                      id="FieldOrigemVenda"
                                      :items="filterData.origensVenda"
                                      item-text="name"
                                      item-value="value"
                                      attach
                                      :disabled="id_documento !== ''"
                                      v-model="custom_filter.origem_venda"
                                      placeholder="Selecione a origem da venda"
                        />
                    </v-col>
                    <v-col cols="6">
                        <Autocomplete id="FieldOrigemAcesso"
                                      label="Origem de Acesso: " outlined
                                      :items="filterData.origensAcesso"
                                      item-text="value"
                                      item-value="value"
                                      attach
                                      v-model="custom_filter.origem_acesso"
                                      placeholder="Selecione a origem de acesso"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <Autocomplete id="FieldMarcas"
                                      label="Marca: " outlined
                                      :items="filterData.marcas"
                                      item-text="name"
                                      item-value="value"
                                      attach
                                      v-model="custom_filter.marca"
                                      placeholder="Selecione a marca"
                        />
                    </v-col>
                    <v-col cols="6">
                        <DynamicSelect label="Usuário: "
                                       id="FieldIdUsuarioErp"
                                       v-model="custom_filter.login"
                                       attach
                                       placeholder="Selecione o Usuário"
                                       endpoint="/dynamic-selects/usuarios/login"
                                       :multiple="false"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <Autocomplete id="FieldHierarquia"
                                      label="Hierarquia Comercial: "
                                      outlined
                                      attach
                                      :items="filterData.perfil_comercial"
                                      item-text="name"
                                      item-value="value"
                                      v-model="custom_filter.perfil_comercial"
                                      placeholder="Selecione a Hierarquia Comercial"
                        />
                    </v-col>
                    <v-col v-if="!isDraft" cols="6">
                        <Autocomplete id="FieldOrigemContrato"
                                      label="Origem Contrato: "
                                      outlined
                                      attach
                                      :items="filterData.origensContrato"
                                      item-text="label"
                                      item-value="value"
                                      clearable
                                      v-model="custom_filter.origem_contrato"
                                      placeholder="Selecione a origem do contrato"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <Autocomplete
                                label="Empresas: "
                                placeholder="Selecione a empresa"
                                id="FieldEmpresa"
                                outlined
                                :items="empresas"
                                :disabled="id_documento !== ''"
                                attach
                                item-text="NM_Empresa"
                                item-value="ID_Empresa"
                                v-model="custom_filter.id_empresa_venda_logada" />
                    </v-col>
                    <v-col cols="6">
                        <Autocomplete id="FieldMultiplasCotas"
                                      label="Múltiplas Cotas: "
                                      outlined
                                      attach
                                      :items="filterData.opcoesSimNAO"
                                      item-text="label"
                                      item-value="value"
                                      v-model="custom_filter.cotas_multiplas"
                                      placeholder="A proposta é múltiplas cotas?"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-text-field
                                label="Cod. Plano de Venda"
                                outlined
                                v-model="custom_filter.cd_plano_venda"
                                :disabled="id_documento !== ''"
                        />
                    </v-col>
                    <v-col cols="6">
                        <Autocomplete
                                label="Tipo de Índice"
                                outlined
                                attach
                                :items="filterData.indicesCorrecao"
                                placeholder="Selecione o tipo de Índice"
                                v-model="custom_filter.tipo_indice"
                                :disabled="id_documento !== ''"
                                item-text="label"
                                item-value="value"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <Autocomplete
                                label="Categoria do Plano"
                                outlined
                                attach
                                :items="TiposDePlano"
                                placeholder="Selecione a categoria do Plano"
                                v-model="custom_filter.categoria_plano"
                                :disabled="id_documento !== ''"
                                item-text="label"
                                item-value="value"
                        />
                    </v-col>
                    <v-col cols="6">
                        <Autocomplete
                                label="Tipo de Grupo"
                                outlined
                                attach
                                :items="TiposGrupoFiltro"
                                placeholder="Selecione o tipo de Grupo"
                                v-model="custom_filter.tipo_grupo"
                                :disabled="id_documento !== ''"
                                item-text="label"
                                item-value="value"
                        />
                    </v-col>
                </v-row>

                <div slot="footer" class="d-flex row-padding">
                    <v-flex class="col flex-basis-0">
                        <v-btn color="secondary" block @click="limparFiltroDetalhado">Limpar Filtros</v-btn>
                    </v-flex>
                    <v-flex class="col flex-basis-0">
                        <v-btn color="primary" block @click="filtrar">Filtrar</v-btn>
                    </v-flex>
                </div>
            </TabDialog>
        </v-card-text>
    </v-card>
</template>

<script>
  import moment from 'moment'
  import { mapState } from 'vuex'
  import { notification } from '@/plugins/helpers'
  import { ListaAgrupamentosDeStatusContrato,
           TiposGrupoFiltro,
           TiposDePlano,
           TiposDeIndice,
           TipoNegociacaoFuroDesc as TipoNegociacaoDesc,
           TipoNegociacaoFuro as TipoNegociacao,
           StatusPedidoDesc as Desc } from '@/plugins/constants'
  import { AlertTypes } from '@/plugins/alerts_types'
  import { DEFAULT_FILTER, DEFAULT_CUSTOM_FILTER } from '../../enums/contratos/defaultFilters'

  export default {
    name: 'FiltrosContratos',
    components: {},
    props: {
      idCarrinho: {
        type: [String, Number]
      },
      filterData: {
        type: Object,
        required: true
      },
      isDraft: {
        type: Boolean,
        required: false
      }
    },
    data: () => ({
      id_documento: '',
      bens: [],
      aba_filtro_visivel: false,
      filter: {
        ...DEFAULT_FILTER
      },
      custom_filter: {
        ...DEFAULT_CUSTOM_FILTER
      },
      data_hora_range: ['', ''],
      limites_filtro: {
        min_prazos: 0,
        max_prazos: 0
      },
      defaultLimitesFiltro: {
        min_prazos: 0,
        max_prazos: 0
      },
      TiposDeIndice,
      TiposDePlano,
      TiposGrupoFiltro
    }),
    computed: {
      ...mapState([ 'empresas' ]),
      unidades () {
        const unidades = this.$session.get('unidades').map(unidade => ({ id_unidade: unidade.id_unidade_negocio, nome: unidade.nm_unidade_negocio, label: `${unidade.cd_unidade_negocio} - ${unidade.nm_unidade_negocio.toUpperCase()}` }))
        return unidades.sort(this.ordenar)
      },
      statusContrato () {
        return Object.values(ListaAgrupamentosDeStatusContrato).map(value => ({ value: value, name: value }))
      },
      tipoNegociacaoFuro () {
        return Object.keys(TipoNegociacao).map(value => ({ value: TipoNegociacao[value], name: TipoNegociacaoDesc[TipoNegociacao[value]] }))
      }
    },
    watch: {
      data_hora_range (nova_data) {
        // Esse format serve para evitar problemas com UTC
        if (nova_data[0]) {
          this.custom_filter.data_inicial = moment(nova_data[0]).format('YYYY-MM-DD')
        } else {
          this.custom_filter.data_inicial = null
        }
        if (nova_data[1]) {
          this.custom_filter.data_final = moment(nova_data[1]).format('YYYY-MM-DD')
        } else {
          this.custom_filter.data_final = null
        }
      },
      id_documento (v) {
        if (v) {
          this.resetFilters()
        }
      },
      idCarrinho (v) {
        this.custom_filter.id_carrinho = v
        this.filtrar()
      },
      aba_filtro_visivel (newVal) {
        this.$refs.TabDialog.TravarScroll(newVal)
      }
    },
    async mounted () {
      try {
        await this.getBens()

        await this.handleLimitesFiltro()
      } catch (error) {
        notification(AlertTypes.ERROR, `Erro ao carregar os dados: ${error.message || error}`)
      }
    },
    methods: {
      resetFilters () {
        this.data_hora_range = ['', '']

        this.custom_filter.range_valor_bem[0] = 0
        this.custom_filter.range_valor_bem[1] = 0

        this.custom_filter = {
          ...DEFAULT_CUSTOM_FILTER
        }

        this.filter = {
          ...DEFAULT_FILTER
        }

        this.limites_filtro.min_prazos = this.defaultLimitesFiltro.min_prazos
        this.limites_filtro.max_prazos = this.defaultLimitesFiltro.max_prazos
        this.custom_filter.range_prazo_comercializacao = [this.limites_filtro.min_prazos, this.limites_filtro.max_prazos]
      },
      limparFiltroDetalhado () {
        this.id_documento = ''
        this.resetFilters()
        this.$refs.form.resetValidation()

        this.filter = { ...this.filter }
        this.custom_filter = { ...this.custom_filter }
        this.aba_filtro_visivel = false

        this.$emit('filter', {
          filter: this.filter,
          custom_filter: this.custom_filter,
          id_documento: this.id_documento
        }
        )
      },
      getStatusPedidosFormatados (pedidos) {
        const pedidosUnicos = new Map()

        pedidos.forEach(pedido => {
          const valor = Desc[pedido.name] ?? pedido.name
          if (valor !== Desc.Rascunho && !pedidosUnicos.has(valor)) {
            pedidosUnicos.set(valor, { ...pedido, name: valor, value: valor })
          }
        })

        return Array.from(pedidosUnicos.values())
      },
      async filtrar () {
        if (!!this.custom_filter.id_carrinho || this.$refs.form.validate()) {
          this.filter = { ...this.filter }
          this.custom_filter = { ...this.custom_filter }
          this.aba_filtro_visivel = false

          this.$emit('filter', {
            filter: this.filter,
            custom_filter: this.custom_filter,
            id_documento: this.id_documento
          }
          )
        }
      },
      abrirFiltro () {
        this.aba_filtro_visivel = true

        if (this.limites_filtro.min_prazos === 0 && this.limites_filtro.max_prazos === 0) {
          this.handleLimitesFiltro()
        }
      },
      async getBens () {
        try {
          const { data } = await this.$http.get('/painel/contrato/bens')
          this.bens = data
        } catch (e) {
          notification(AlertTypes.ERROR, e, 'Não foi possível buscar os status do contrato')
        }
      },
      async carregarLimitesFiltro () {
        try {
          const res = await this.$http.get('/painel/contrato/limites_prazos')
          return res.data
        } catch (e) {
          notification(AlertTypes.ERROR, e, 'Não foi possível carregar os dados do filtro')
          return null
        }
      },
      async handleLimitesFiltro () {
        const limitesFiltro = await this.carregarLimitesFiltro()
        if (limitesFiltro && limitesFiltro.length > 0) {
          const { min_prazos, max_prazos } = limitesFiltro[0]
          this.limites_filtro = { min_prazos, max_prazos }
          this.defaultLimitesFiltro.min_prazos = min_prazos
          this.defaultLimitesFiltro.max_prazos = max_prazos

          this.custom_filter.range_prazo_comercializacao = [min_prazos, max_prazos]
        }
      }
    }
  }
</script>
